export default __webpack_public_path__ + "static/media/emenike.b2ec6d5a.png";